import { createRouter, createWebHashHistory } from 'vue-router';
//import MainPage from '@/pages/MainPage.vue';
import LoginPage from '@/pages/LoginPage.vue';

const routes = [
    {
        path: '/',
        name: 'root',
        component: LoginPage,
        meta: { title: '경상남도 버스경영수지 분석시스템(BCS)', layout: 'public', authRequired: false },
    },
    /****************************************
     *  메인화면
     ****************************************/
    {
        path: '/MainPage',
        name: 'MainPage',
        //component: Dashboard,
        component: () => import('./pages/MainPage.vue'),
        meta: { title: '메인화면', layout:null, authRequired: false },
    },
    {
        path: '/SignupPage',
        name: 'SignupPage',
        component: () => import('@/components/SignUpPage.vue'),
        meta: { title: '회원가입', layout:'join', authRequired: false },
    },
    {
        path: '/LoginPage',
        name: 'LoginPage',
        //component: () => import('@/components/LoginPage.vue'),
        component: () => import('./pages/LoginPage.vue'),
        meta: { title: '로그인', layout:'public', authRequired: false },
    },
    {
        path: '/AccountPage',
        name: 'AccountPage',
        component: () => import('./pages/AccountPage.vue'),
        meta: { title: '개인정보 변경', layout:null, authRequired: true },
    },
    {
        path: '/PasswordPage',
        name: 'PasswordPage',
        component: () => import('./pages/PasswordPage.vue'),
        meta: { title: '암호 변경', layout:null, authRequired: true },
    },
    /****************************************
     *  시스템관리 - 운영관리
     ****************************************/
    {
        path: '/CodeHelpsPage',
        name: 'CodeHelpsPage',
        component: () => import('./pages/cm/CodeHelpsPage.vue'),
        meta: { title:'코드도움 관리', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/EnvCodesPage',
        name: 'EnvCodesPage',
        component: () => import('./pages/cm/EnvCodesPage.vue'),
        meta: { title: '운영환경 설정', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/CodesPage',
        name: 'CodesPage',
        component: () => import('./pages/cm/CodesPage.vue'),
        meta: { title: '코드 관리', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/MenusPage',
        name: 'MenusPage',
        component: () => import('./pages/cm/MenusPage.vue'),
        meta: { title: '메뉴 관리', sub: '메뉴를 관리 한다', layout: null, authRequired: false, titleOrigin: '시스템관리'},
    },
    {
        path: '/ProgramsPage',
        name: 'ProgramsPage',
        component: () => import('./pages/cm/ProgramsPage.vue'),
        meta: { title: '프로그램 관리', sub: '프로그램을 관리 한다', layout: null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/UsersPage',
        name: 'UsersPage',
        component: () => import('./pages/cm/UsersPage.vue'),
        meta: { title: '사용자 등록', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/CustsPage',
        name: 'CustsPage',
        component: () => import('./pages/ma/CustsPage.vue'),
        meta: { title: '업체 등록', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/LoginLogPage',
        name: 'LoginLogPage',
        component: () => import('./pages/cm/LoginLogPage.vue'),
        meta: { title: '로그인로그', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/LoginDailyLogPage',
        name: 'LoginDailyLogPage',
        component: () => import('./pages/cm/LoginDailyLogPage.vue'),
        meta: { title: '일일 로그인현황', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    {
        path: '/QueryPage',
        name: 'QueryPage',
        component: () => import('./pages/cm/QueryPage.vue'),
        meta: { title: 'SQL쿼리', layout:null, authRequired: true, titleOrigin: '시스템관리'},
    },
    /****************************************
     *  시스템관리 - 업무관리
     ****************************************/
    {
        path: '/MA201010Page',
        name: 'MA201010Page',
        component: () => import('./pages/ma/MA201010Page.vue'),
        meta: { title: '전자신고결과관리', sub: '전자신고결과를 관리한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201020Page',
        name: 'MA201020Page',
        component: () => import('./pages/ma/MA201020Page.vue'),
        meta: { title: '전자신고결과집계조회', sub: '전자신고결과집계를 조회한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201030Page',
        name: 'MA201030Page',
        component: () => import('./pages/ma/MA201030Page.vue'),
        meta: { title: '전자신고자료입력현황', sub: '전자신고자료입력현황을 조회한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201040Page',
        name: 'MA201040Page',
        component: () => import('./pages/ma/MA201040Page.vue'),
        meta: { title: '전자신고관리제어', sub: '전자신고관리제어를 조회한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201050Page',
        name: 'MA201050Page',
        component: () => import('./pages/ma/MA201050Page.vue'),
        meta: { title: '비용세분류등록', sub: '비용세분류등록을 관리한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201060Page',
        name: 'MA201060Page',
        component: () => import('./pages/ma/MA201060Page.vue'),
        meta: { title: '평가차수관리', sub: '평가차수를 관리 한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201070Page',
        name: 'MA201070Page',
        component: () => import('./pages/ma/MA201070Page.vue'),
        meta: { title: '표준원가관리', sub: '표준원가를 관리 한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201080Page',
        name: 'MA201080Page',
        component: () => import('./pages/ma/MA201080Page.vue'),
        meta: { title: '실차관리', sub: '실차 정보를 관리 한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    {
        path: '/MA201090Page',
        name: 'MA201090Page',
        component: () => import('./pages/ma/MA201090Page.vue'),
        meta: { title: '마감관리', sub: '마감 정보를 관리 한다', layout: null, authRequired: true, titleOrigin: '업무관리'},
    },
    /****************************************
     *  기준정보
     ****************************************/
    {
        path: '/MA301010Page',
        name: 'MA301010Page',
        component: () => import('./pages/ma/MA301010Page.vue'),
        meta: { title: '계통관리', sub: '계통 정보를 관리한다', layout: null, authRequired: true, titleOrigin: '기준정보관리'},
    },
    {
        path: '/MA301020Page',
        name: 'MA301020Page',
        component: () => import('./pages/ma/MA301020Page.vue'),
        meta: { title: '노선관리', sub: '노선 정보를 관리한다', layout: null, authRequired: true, titleOrigin: '기준정보관리'},
    },
    {
        path: '/MA301030',
        name: 'MA301030',
        component: () => import('./pages/ma/MA301030.vue'),
        meta: { title: '차량관리', sub: '차량 정보를 관리한다', layout: null, authRequired: true, titleOrigin: '기준정보관리'},
    },
    {
        path: '/MA301040',
        name: 'MA301040',
        component: () => import('./pages/ma/MA301040.vue'),
        meta: { title: '차고지관리', sub: '차고지 정보를 관리한다', layout: null, authRequired: true, titleOrigin: '기준정보관리'},
    },
    /****************************************
     *  원가기타
     ****************************************/
    {
        path: '/MA502010',
        name: 'MA502010',
        component: () => import('./pages/ma/MA502010.vue'),
        meta: { title: '유류비', sub: '유류비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    }, 

    {
        path: '/MA502020',
        name: 'MA502020',
        component: () => import('./pages/ma/MA502020.vue'),
        meta: { title: '유류보조금', sub: '유류보조금 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    }, 

    {
        path: '/MA502030',
        name: 'MA502030',
        component: () => import('./pages/ma/MA502030.vue'),
        meta: { title: '차량유지비', sub: '차량유지비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    }, 

    {
        path: '/MA502040',
        name: 'MA502040',
        component: () => import('./pages/ma/MA502040.vue'),
        meta: { title: '보험료', sub: '보험료 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502050',
        name: '기사급여',
        component: () => import('./pages/ma/MA502050.vue'),
        meta: { title: '기사급여', sub: '기사급여 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502060',
        name: 'MA502060',
        component: () => import('./pages/ma/MA502060.vue'),
        meta: { title: '기사외급여비율', sub: '기사외급여비율 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502070',
        name: 'MA502070',
        component: () => import('./pages/ma/MA502070.vue'),
        meta: { title: '시설유지비', sub: '시설유지비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502071',
        name: 'MA502071',
        component: () => import('./pages/ma/MA502071.vue'),
        meta: { title: '시설유지비(test)', sub: '시설유지비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502080',
        name: 'MA502080',
        component: () => import('./pages/ma/MA502080.vue'),
        meta: { title: '시설점유비', sub: '시설점유비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502090',
        name: 'MA502090',
        component: () => import('./pages/ma/MA502090.vue'),
        meta: { title: '인력활동비', sub: '인력활동비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502100',
        name: 'MA502100',
        component: () => import('./pages/ma/MA502100.vue'),
        meta: { title: '기타감가상각', sub: '기타감가상각 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502110',
        name: 'MA502110',
        component: () => import('./pages/ma/MA502110.vue'),
        meta: { title: '기타원가항목', sub: '기타원가항목 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502120',
        name: 'MA502120',
        component: () => import('./pages/ma/MA502120.vue'),
        meta: { title: '감가상각비', sub: '감가상각비 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    {
        path: '/MA502130',
        name: 'MA502130',
        component: () => import('./pages/ma/MA502130.vue'),
        meta: { title: '표준운행원가', sub: '표준운행원가 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '기타원가관리'},
    },

    /****************************************
     *  집계자료
     ****************************************/
    {
        path: '/MA601010',
        name: 'MA601010',
        component: () => import('./pages/ma/MA601010.vue'),
        meta: { title: '운행일지집계현황', sub: '운행일지집계현황 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '집계자료관리'},
    },
    
    {
        path: '/MA601020',
        name: 'MA601020',
        component: () => import('./pages/ma/MA601020.vue'),
        meta: { title: '주유집계현황', sub: '주유집계현황 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '집계자료관리' },
    },

    {
        path: '/MA601030',
        name: 'MA601030',
        component: () => import('./pages/ma/MA601030.vue'),
        meta: { title: '비용집계현황', sub: '비용집계현황 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '집계자료관리' },
    },

    {
        path: '/MA601040',
        name: 'MA601040',
        component: () => import('./pages/ma/MA601040.vue'),
        meta: { title: '수입지출집계현황', sub: '수입지출집계현황 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '집계자료관리' },
    },

   {
        path: '/MA601050',
        name: 'MA601050',
        component: () => import('./pages/ma/MA601050.vue'),
        meta: { title: '손익집계현황', sub: '손익집계현황 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '집계자료관리' },
    },
    
    {
        path: '/MA601060',
        name: 'MA601060',
        component: () => import('./pages/ma/MA601060.vue'),
        meta: { title: '보조금지급예상액', sub: '보조금지급예상액 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '집계자료관리'},
    },
    /****************************************
     *  전자신고 - 전자신고관리
     ****************************************/
    {
        path: '/MA301050',
        name: 'MA301050',
        component: () => import('./pages/ma/MA301050.vue'),
        meta: { title: '운행일지관리', sub: '', layout:null, authRequired: true, titleOrigin: '전자신고관리'},
    },
    {
        path: '/MA301060',
        name: 'MA301060',
        component: () => import('./pages/ma/MA301060.vue'),
        meta: { title: '주유일지관리', sub: '', layout:null, authRequired: true, titleOrigin: '전자신고관리'},
    },
    {
        path: '/MA301070',
        name: 'MA301070',
        component: () => import('./pages/ma/MA301070.vue'),
        meta: { title: '비용일지관리', sub: '', layout:null, authRequired: true, titleOrigin: '전자신고관리'},
    },
    {
        path: '/MA301080',
        name: 'MA301080',
        component: () => import('./pages/ma/MA301080.vue'),
        meta: { title: '운행일지집계', sub: '', layout:null, authRequired: true, titleOrigin: '전자신고관리'},
    },
    {
        path: '/MA301090',
        name: 'MA301090',
        component: () => import('./pages/ma/MA301090.vue'),
        meta: { title: '주유일지집계', sub: '', layout:null, authRequired: true, titleOrigin: '전자신고관리'},
    },
    {
        path: '/MA301100',
        name: 'MA301100',
        component: () => import('./pages/ma/MA301100.vue'),
        meta: { title: '비용일지집계', sub: '', layout:null, authRequired: true, titleOrigin: '전자신고관리'},
    },
     /****************************************
     *  분석관리
     ****************************************/
    {
        path: '/MA401010',
        name: 'MA401010',
        component: () => import('./pages/ma/MA401010.vue'),
        meta: { title: '차량별운행수입조회', sub: '차량별운행수입을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리'},
    },
    {
        path: '/MA401020',
        name: 'MA401020',
        component: () => import('./pages/ma/MA401020.vue'),
        meta: { title: '노선별운행수입조회', sub: '노선별운행수입을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리'},
    },
    {
        path: '/MA401030',
        name: 'MA401030',
        component: () => import('./pages/ma/MA401030.vue'),
        meta: { title: '업체별전자신고집계조회', sub: '업체별전자신고집계를 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리'},
    },
    {
        path: '/MA401040',
        name: 'MA401040',
        component: () => import('./pages/ma/MA401040.vue'),
        meta: { title: '업체별승차수입금액현황', sub: '업체별승차수입금액을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    {
        path: '/MA401050',
        name: 'MA401050',
        component: () => import('./pages/ma/MA401050.vue'),
        meta: { title: '연비분석', sub: '연비분석을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    {
        path: '/MA401060',
        name: 'MA401060',
        component: () => import('./pages/ma/MA401060.vue'),
        meta: { title: '사용연료별버스대수현황', sub: '사용연료별버스대수현황을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    {
        path: '/MA401070',
        name: 'MA401070',
        component: () => import('./pages/ma/MA401070.vue'),
        meta: { title: '운행거리분석현황', sub: '운행거리분석현황을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    {
        path: '/MA401080',
        name: 'MA401080',
        component: () => import('./pages/ma/MA401080.vue'),
        meta: { title: '노선대비계통현황', sub: '노선대비계통현황을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    {
        path: '/MA401090',
        name: 'MA401090',
        component: () => import('./pages/ma/MA401090.vue'),
        meta: { title: '수입금액편차분석', sub: '수입금액편차분석을 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    {
        path: '/MA401095',
        name: 'MA401095',
        component: () => import('./pages/ma/MA401095.vue'),
        meta: { title: '원가및운송수입조회', sub: '원가및운송수입조회를 조회한다', layout: null, authRequired: true, titleOrigin: '분석관리' },
    },
    /****************************************
     *  원가관리
     ****************************************/
    {
        path: '/MA501030',
        name: 'MA501030',
        component: () => import('./pages/ma/MA501030.vue'),
        meta: { title: '운행노선별 손익분석', sub: '운행노선별 손익분석 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },

    {
        path: '/MA501040',
        name: 'MA501040',
        component: () => import('./pages/ma/MA501040.vue'),
        meta: { title: '인가노선별 손익분석', sub: '인가노선별 손익분석 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },

    {
        path: '/MA501050',
        name: 'MA501050',
        component: () => import('./pages/ma/MA501050.vue'),
        meta: { title: '노선차량별배분현황', sub: '노선차량별배분현황 정보를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },
    
    {
        path: '/MA501060',
        name: 'MA501060',
        component: () => import('./pages/ma/MA501060.vue'),
        meta: { title: '운행노선별손익집계', sub: '운행노선별손익집계를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },
    {
        path: '/MA501070',
        name: 'MA501070',
        component: () => import('./pages/ma/MA501070.vue'),
        meta: { title: '인가노선별손익집계', sub: '인가노선별손익집계를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },
    {
        path: '/MA501080',
        name: 'MA501080',
        component: () => import('./pages/ma/MA501080.vue'),
        meta: { title: '인가노선별운행분석표', sub: '인가노선별운행분석표를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },
    {
        path: '/MA501090',
        name: 'MA501090',
        component: () => import('./pages/ma/MA501090.vue'),
        meta: { title: '운행노선별상세손익분석', sub: '운행노선별상세손익분석표를 조회한다', layout: null, authRequired: true, titleOrigin: '손익분석관리' },
    },
    /****************************************
     *  게시판
     ****************************************/
    {
        path: '/MA601070',
        name: 'MA601070',
        component: () => import('./pages/ma/MA601070.vue'),
        meta: { title: '공지사항', sub: '공지사항을 조회한다', layout: null, authRequired: true, titleOrigin: '게시판관리' },
    },
    {
        path: '/MA601080',
        name: 'MA601080',
        component: () => import('./pages/ma/MA601080.vue'),
        meta: { title: '수정사항요청', sub: '수정사항을 조회한다', layout: null, authRequired: true, titleOrigin: '게시판관리' },
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

/**
 * 메뉴 클릭 등 라우터 경로가 변경되는 경우 (페이지내에서 조회 시에는 동작하지 않음)
 */
router.beforeEach((to, from, next) => {
    //console.log("## at router.beforeEach : to = "+ to + ", from = "+ from + ", next = "+ next);
    
    if (to.meta.authRequired) {
        if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
            // 로그인 정보가 없거나 토큰이 없으면 홈 화면으로 이동한다
            next("/#/LoginPage");
        } else {
            next();
        }
    } else {
        next();
    }
});

// const beforeAuth = isAuth => (to, from, next) => {
//     // 인증이 필요한 페이지일 경우 인증 체크
//     const token = window.sessionStorage.getItem("token");
//     //const isAuthenticated = store.getters["isAuthenticated"]

//     if ((token && isAuth) || (!token && !isAuth)) {
//         return next()
//     } else {
//         // 홈 화면으로 이동
//         next("/#/MainPage")
//     }
// };

export default router;
